import { Machine, MachineConfig, MachineOptions, assign } from 'xstate';

// how long to display notifications for
const NOTIFICATION_INTERVAL = 5000;

interface NotificationSchema {
  states: {
    default: {};
    shown: {};
  };
}

export interface NotificationEvent {
  type: 'SHOW_MESSAGE';
  data: any;
}

interface NotificationMsg {
  type: string;
  message: string;
  isVisible: boolean;
}

export interface NotificationContext {
  notification?: NotificationMsg;
}

const config: MachineConfig<
  NotificationContext,
  NotificationSchema,
  NotificationEvent
> = {
  id: 'notifications',
  initial: 'default',
  on: {
    SHOW_MESSAGE: {
      target: 'shown',
      actions: ['assignMessage'],
    },
  },
  context: {},
  states: {
    default: {},
    shown: {
      after: {
        [NOTIFICATION_INTERVAL]: {
          target: 'default',
          actions: 'clearMessage',
        },
      },
    },
  },
};

const options: Partial<MachineOptions<
  NotificationContext,
  NotificationEvent
>> = {
  actions: {
    assignMessage: assign((_, event: any) => {
      const defaultMessage = 'Something went wrong, please try again';
      const message =
        event.data?.error?.graphQLErrors?.[0]?.message || defaultMessage;
      return {
        notification: {
          message,
          type: 'error',
          isVisible: true,
        },
      };
    }),
    clearMessage: assign((context) => ({
      notification: {
        ...context.notification!,
        isVisible: false,
      },
    })),
  },
};

const notificationMachine = Machine(config, options);

export default notificationMachine;
